import { Box, Group, Stack, Text, TextInput } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import { IconCalendar } from '@tabler/icons-react';
import { Button } from 'src/design-system/Button';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import { toDueDateIso } from 'src/meetings/utils/date-utils';

export type ActionDraft = {
  description: string;
  owner: string;
  dueDate: string | null;
  notes: string;
};

export const EMPTY_DRAFT: ActionDraft = { description: '', owner: '', dueDate: null, notes: '' };

const NOTES_MAX_LENGTH = 255;

type Props = {
  title: string;
  value: ActionDraft;
  submitLabel: string;
  isSubmitting?: boolean;
  onChange: (next: ActionDraft) => void;
  onSubmit: () => void;
  onCancel: () => void;
};

export const MeetingActionForm = ({
  title,
  value,
  submitLabel,
  isSubmitting,
  onChange,
  onSubmit,
  onCancel,
}: Props) => (
  <Box p="md" style={{ border: '1px solid var(--mantine-color-gray-1)', borderRadius: 16 }}>
    <Stack gap="sm">
      <Text size="textMd" fw={FONT_WEIGHTS.semibold} c="gray.10">
        {title}
      </Text>
      <Group gap="xs" align="flex-start" grow>
        <TextInput
          label="Action"
          placeholder="What needs to happen?"
          value={value.description}
          onChange={e => onChange({ ...value, description: e.currentTarget.value })}
        />
        <TextInput
          label="Owner"
          placeholder="Not stated"
          value={value.owner}
          onChange={e => onChange({ ...value, owner: e.currentTarget.value })}
        />
        <DateInput
          label="Due date"
          placeholder="No date"
          value={value.dueDate}
          onChange={date => onChange({ ...value, dueDate: toDueDateIso(date) })}
          leftSection={<IconCalendar size={16} />}
          valueFormat="D MMM YYYY"
          clearable
        />
        <TextInput
          label="Notes"
          placeholder="Anything worth recording"
          maxLength={NOTES_MAX_LENGTH}
          value={value.notes}
          onChange={e => onChange({ ...value, notes: e.currentTarget.value })}
        />
      </Group>
      <Group gap="xs">
        <Button
          variant="primary"
          size="xs"
          onClick={onSubmit}
          loading={isSubmitting}
          disabled={!value.description.trim()}
        >
          {submitLabel}
        </Button>
        <Button variant="tertiary" size="xs" onClick={onCancel}>
          Cancel
        </Button>
      </Group>
    </Stack>
  </Box>
);
